import {
  FETCH_STONE_QUALITY_REQUEST,
  FETCH_STONE_QUALITY_SUCCESS,
  FETCH_STONE_QUALITY_FAILURE,
  ADD_STONE_QUALITY_REQUEST,
  ADD_STONE_QUALITY_SUCCESS,
  ADD_STONE_QUALITY_FAILURE,
  UPDATE_STONE_QUALITY_REQUEST,
  UPDATE_STONE_QUALITY_SUCCESS,
  UPDATE_STONE_QUALITY_FAILURE,
  DELETE_STONE_QUALITY_REQUEST,
  DELETE_STONE_QUALITY_SUCCESS,
  DELETE_STONE_QUALITY_FAILURE,
  STONE_QUALITY_FORM_ERROR,
  STONE_QUALITY_FORM_SUCCESS,
  SET_STONE_QUALITY_EDIT,
  CLEAR_STONE_QUALITY_EDIT,
} from '../../../../types/masters/stoneAttribute/stoneQuality/stoneQualityTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingStoneQuality: null,
};

const stoneQualityReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STONE_QUALITY_REQUEST:
    case ADD_STONE_QUALITY_REQUEST:
    case UPDATE_STONE_QUALITY_REQUEST:
    case DELETE_STONE_QUALITY_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_STONE_QUALITY_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_STONE_QUALITY_SUCCESS:
    case UPDATE_STONE_QUALITY_SUCCESS:
    case DELETE_STONE_QUALITY_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_STONE_QUALITY_FAILURE:
    case ADD_STONE_QUALITY_FAILURE:
    case UPDATE_STONE_QUALITY_FAILURE:
    case DELETE_STONE_QUALITY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case STONE_QUALITY_FORM_ERROR:
      return { ...state, loading: false, formError: action.payload };
    case STONE_QUALITY_FORM_SUCCESS:
      return { ...state, loading: false, formSuccess: action.payload };
    case SET_STONE_QUALITY_EDIT:
      return { ...state, editingStoneQuality: action.payload };
    case CLEAR_STONE_QUALITY_EDIT:
      return { ...state, editingStoneQuality: null };
    default:
      return state;
  }
};

export default stoneQualityReducer; 